export function arrayBufferToString(buffer: ArrayBuffer) {
  let text = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    text += String.fromCharCode(bytes[i]);
  }
  return text;
}

export const calculateDepth = (currentDepth: number) => (element: { depth?: number; children?: any[] }) => {
  element.depth = currentDepth;
  (element.children || []).forEach(calculateDepth(currentDepth + 1));
};

/**
 *
 * @description
 * Reason for the method:
 * When the time zone offset is absent, date-only forms are interpreted as a UTC time and date-time forms
 * are interpreted as local time. This is due to a historical spec error that was not consistent with
 * ISO 8601 but could not be changed due to web compatibility. See Broken Parser – A Web Reality Issue.
 *
 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format
 * Issue ticket: https://eagleeyenetworks.atlassian.net/browse/EEPD-31979
 *
 * @param {string | Date} localDateString provide date in format: YYYY-MM-DD
 * @return {Date}
 */
export const getDateFromLocalDate = (localDateString: string | Date): Date => {
  const YYYYMMDDFormatRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])$/;
  if (typeof localDateString === 'string' && YYYYMMDDFormatRegex.test(localDateString)) {
    return new Date(`${localDateString}T00:00:00`);
  }
  return new Date(localDateString);
};

/**
 * @description Method to get plain auth key from jwt token
 * @param {string} token jwt token
 * @returns {string} plain auth key
 * @example getPlainAuthKeyFromJwt('eyJ ...') // returns 'vms_cluster~jti'
 */
export function getPlainAuthKeyFromJwt(token: string) {
  try {
    const base64HeaderUrl = token.split('.')[0];
    const base64Header = base64HeaderUrl.replace('-', '+').replace('_', '/');
    const headerData = JSON.parse(window.atob(base64Header));
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const dataJWT = JSON.parse(window.atob(base64));
    dataJWT.header = headerData;
    return dataJWT.vms_cluster + '~' + dataJWT.jti;
  } catch (err) {
    console.error('Error while getting plain auth key from jwt - ', err);
    return false;
  }
}

export function preventScrollBubbling(el: HTMLElement) {
  el?.addEventListener(
    'wheel',
    function (e: WheelEvent) {
      const { scrollTop, scrollHeight, clientHeight } = el;
      const delta = e.deltaY;

      if (!(e?.target instanceof HTMLElement)) {
        return;
      }

      if (e?.target?.closest('.v-list-group__items')) {
        return;
      }

      const atTop = scrollTop === 0;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1;

      // If not scrollable or at scroll edge
      if ((atTop && delta < 0) || (atBottom && delta > 0) || scrollHeight <= clientHeight) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    { passive: false }
  );
}
